import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {Link, useHistory, useLocation} from "react-router-dom";
import React, {useEffect, useState} from "react";

import {ReactComponent as BillPayment} from "../assets/svg/Application/UnregBusiness/BillPayment.svg";
// import {ReactComponent as BroadPay} from "../assets/svg/Logo/zambia-logo.svg";
import {ReactComponent as CurrentAccount} from "../assets/svg/Application/UnregBusiness/BusinessAndCurrentAccount2.svg";
import {ReactComponent as ExpenseManagement} from "../assets/svg/Application/UnregBusiness/ExpenseManagement.svg";
import {ReactComponent as Growth} from "../assets/svg/Application/UnregBusiness/Funding.svg";
import {ReactComponent as LencoLogo} from "../assets/images/LencoLogo.svg";
import {ReactComponent as PayOut} from "../assets/svg/Application/UnregBusiness/Payout.svg";
import PhysicalAndVirtualCards from "../assets/svg/Application/UnregBusiness/cardsImage.png";
import Slider from "react-slick";

// const homeUrl: string = process.env.REACT_APP_HOME_URL || "/";
interface LayoutProps {
	children: React.ReactNode;
	showHeaderSignUp?: boolean;
	showHeaderLogin?: boolean;
	inviteURL?: string;
	showNothing?: boolean;
}

function Layout({children, showNothing = false, showHeaderLogin = true, inviteURL = ""}: LayoutProps): JSX.Element {
	const settings = {
		infinite: true,
		slidesToShow: 1,
		dots: true,
		autoplay: true,
		autoplaySpeed: 8000,
		slidesToScroll: 1,
		speed: 500,
		pauseOnHover: true,
	};

	const history = useHistory();
	const location = useLocation();

	const [isShowLogin, setIsShowLogin] = useState<boolean>(false);

	useEffect(() => {
		setIsShowLogin(
			location.pathname.includes("/signup") ||
				location.pathname.includes("/forgot-password") ||
				location.pathname.includes("/signup/business-type") ||
				location.pathname.includes("/signup/account") ||
				location.pathname.includes("/wait-list") ||
				location.pathname.includes("/director") ||
				location.pathname.includes("/referee")
		);
	}, [location]);

	return (
		<>
			<div
				className="layout-section grid h-screen w-full grid-cols-1 overflow-x-hidden bg-white lg:grid-cols-12 lg:bg-blue-backdrop"
				tabIndex={-1}
			>
				<div className="relative col-span-7 m-0 flex h-full w-full  flex-col bg-white p-0" tabIndex={-1}>
					<div className="flex items-center justify-between px-4 pt-6 2xs:px-10">
						<div onClick={() => history.push("/login")}>
							{/* {isCountryZambia ? <BroadPay className="lg:w-full" /> : <LencoLogo className="lg:w-full" />} */}
							<LencoLogo className="lg:w-full" />
						</div>
					</div>
					<main className="w-full max-w-6xl flex justify-center items-center flex-col h-full overflow-y-auto relative">
						{children}
						<div className="py-8">
							{!showNothing && isShowLogin && showHeaderLogin && location.pathname !== "/" && (
								<p className="flex flex-row text-black-tertiary text-sm space-x-2 font-normal pt-2">
									<span className="flex -mr-1"> Already have an account?</span>
									<Link to={inviteURL || "/login"}>
										<span className=" whitespace-nowrap text-blue">Log In</span>
									</Link>
								</p>
							)}
							{!showNothing && !isShowLogin && location.pathname !== "/" && (
								<div>
									<p className="flex flex-row text-black-tertiary text-sm space-x-2 font-normal pt-2">
										<span className="-mr-1"> Don&apos;t have a Lenco account?</span>
										<Link to={inviteURL || "/signup"}>
											<span className="text-blue whitespace-nowrap">Sign Up</span>
										</Link>
									</p>
								</div>
							)}
						</div>
					</main>
				</div>

				<div
					className="LandingSlider invisible col-span-5 flex h-0 flex-row justify-center overflow-hidden bg-white lg:visible lg:h-full lg:flex-col lg:bg-blue-senary"
					tabIndex={-1}
				>
					<Slider {...settings} className="" tabIndex={-1}>
						<div className="item" tabIndex={-1}>
							<CurrentAccount className="m-auto" style={{height: "352px", width: "80%"}} />
							<div className=" mt-12 text-center">
								<h1 className="text-2xl font-bold text-black">Business Current Account</h1>

								<div className="pt-6 text-center text-sm   font-normal text-black-secondary">
									<p>Real bank accounts for fast growing businesses.</p>
									<p>These account accept all forms of deposits.</p>
								</div>
							</div>
						</div>
						<div className="item" tabIndex={-1}>
							<PayOut className="m-auto" style={{height: "400px", width: "80%"}} tabIndex={-1} />
							<div className=" mb-5 text-center">
								<h1 className="text-2xl font-bold text-black">Payout</h1>

								<div className="flex flex-col items-center  justify-center  pt-6 text-center text-sm font-normal text-black-secondary">
									<p>Make up to 5,000 payments instantly with no effort.</p>

									<p>Upload a file to make bulk payouts from the dashboard or</p>
									<p>Integrate our API to automate instant payouts.</p>
								</div>
							</div>
						</div>
						<div className="item" tabIndex={-1}>
							<ExpenseManagement className="m-auto" style={{height: "352px", width: "80%"}} />

							<div className=" mt-12 text-center">
								<h1 className="text-2xl font-bold text-black">Expense Management</h1>

								<div className="pt-6 text-center  text-sm  font-normal text-black-secondary">
									<p>Experience the power of automated reconciliation</p>
									<p>with transaction categorization, recipient grouping and</p>
									<p> post transaction comments.</p>
								</div>
							</div>
						</div>

						<div className="item" tabIndex={-1}>
							<BillPayment className="m-auto" style={{height: "352px", width: "80%"}} />

							<div className=" mt-12 text-center">
								<h1 className="text-2xl font-bold text-black">Bill Payment</h1>
							</div>
							<div className="pt-6 text-center   text-sm font-normal text-black-secondary">
								<p>Your business airtime and Utility bill in one place.</p>
								<p>Built for your team in mind.</p>
							</div>
						</div>
						<div className="item" tabIndex={-1}>
							<Growth className="m-auto" style={{height: "352px", width: "80%"}} />
							<div className=" mt-12 text-center">
								<h1 className="text-2xl font-bold text-black">Growth</h1>
							</div>
							<div className="pt-6 text-center text-sm  font-normal text-black-secondary">
								<p>Best growth capital available for your business.</p>
								<p>Opt-in to see your growth capital limit.</p>
								<p>No request. Money is in your account already.</p>
							</div>
						</div>
						<div className="item" tabIndex={-1}>
							<img src={PhysicalAndVirtualCards} className="m-auto mt-10" style={{height: "auto", width: "80%"}} />

							<div className=" mb-7 mt-10 text-center">
								<div className="flex flex-col items-center justify-center space-y-3 ">
									<h1 className="text-2xl font-bold text-black ">Physical and Virtual cards</h1>
									<div className="rounded-lg bg-warning-backdrop p-1.5 text-xs text-warning">Coming soon</div>
								</div>
							</div>
							<div className="pb-6 text-center   text-sm  font-normal text-black-secondary">
								<p>Issue cards for your team to better track spending</p>
								<p>and manage your business. All our cards come</p>
								<p>with custom card management and access control.</p>
							</div>
						</div>
					</Slider>
				</div>
			</div>
		</>
	);
}

export default Layout;
